import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=bb36828e&scoped=true&"
import script from "./CustomerAddress.vue?vue&type=script&lang=js&"
export * from "./CustomerAddress.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAddress.vue?vue&type=style&index=0&id=bb36828e&scoped=true&lang=css&"
import style1 from "./CustomerAddress.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb36828e",
  null
  
)

export default component.exports